export default "__VITE_ASSET__CfwSixzt__"